module.exports = __webpack_public_path__ + "static/18-a0fe69aa789381edff0da99db0c14522.jpg";